import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ShipperOptionsResponse } from 'src/entities/Report.entity';

const requestPath = '/api/v5/reports/shippers';
const queryPrefix = 'useShipperOptionsQuery';

type Params = {
  startOn: string;
  endOn: string;
  enabled?: boolean;
};

const fetchShippers = ({ startOn, endOn }: Params) => async () => {
  const response = await axios.get<ShipperOptionsResponse>(requestPath, {
    params: { start_on: startOn, end_on: endOn },
  });
  return response.data;
};

export const useShipperOptionsQuery = ({ startOn, endOn, enabled = true }: Params) => useQuery(
  [queryPrefix, { startOn, endOn }],
  fetchShippers({ startOn, endOn }),
  {
    staleTime: Infinity,
    enabled: enabled && Boolean(startOn) && Boolean(endOn),
  },
);
